import { render, staticRenderFns } from "./musicDetail.vue?vue&type=template&id=2aaa3356&scoped=true&"
import script from "./musicDetail.vue?vue&type=script&lang=js&"
export * from "./musicDetail.vue?vue&type=script&lang=js&"
import style0 from "./musicDetail.vue?vue&type=style&index=0&id=2aaa3356&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aaa3356",
  null
  
)

export default component.exports